import "./style.css";
import { useUserInfo } from "../../../../context/user";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import NangoIntegration from "./Nango";
import { loadConfig } from "../../../../config";
import { useAgentsList } from "../../../../queries/agents";
import {
  useSuperAdminSettings,
  useCheckCrmAgent,
  useCreateCrmAgent,
  useUpdateStreamingApi,
  useSaveAccountToken,
  useCreateApiKey,
  useCheckSlackConnection,
  useFetchSlackConnection,
  useUpdateSlackConnection,
} from "../../../../queries/integrations";


function IntegrationsContent() {
  const user = useUserInfo()[0];
  const checkIfGhlUser = useUserInfo()[9];
  const activeLocation = useUserInfo()[4];
  const isConnected = useUserInfo()[13];
  const UpdateUser = useUserInfo()[1];
  const saveActiveLocation = useUserInfo()[5];
  const agencyData = useUserInfo()[11]
  const GHLSessionKey = useUserInfo()[14];
  const [showApiKey, setShowApiKey] = useState(false);
  const [apiKey, setApiKey] = useState(activeLocation?.apiKey);
  const [isModalOpen, setisModalOpen] = useState(false)
  const [Modalcontent, setModalcontent] = useState('')
  const [isToggled, setIsToggled] = useState(false);
  const [myResponder, setMyResponder] = useState();
  const [processing, setProcessing] = useState(false);
  const [userComment, setUserComment] = useState('');
  const [updatedByUser, setUpdatedByUser] = useState();
  const [preFixPrompt, setPreFixPrompt] = useState('');
  const [postFixPrompt, setPostFixPrompt] = useState('');
  const [defaultprompt, setdefaultprompt] = useState({});
  const contextuploadFilefrominput = useUserInfo()[16];
  const [mediaLibraryModel, setMediaLibraryModel] = useState(false);
  const [modelContent, setModelContent] = useState('');
  const [openAssistantModal, setOpenAssistantModal] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [thirdPartFiles, setThirdPartyFiles] = useState([]);
  const [hidebtn, setHidebtn] = useState(true);
  const userInfo = useUserInfo()[0];
  const [isCRMLoaderModal, setisCRMLoaderModal] = useState(false)


  const [assistantError, setAssistantError] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");
  const [loader, setLoader] = useState(false);
  const [nangoLogin, setNangoLogin] = useState(false);

  const userActiveLocation = useUserInfo()[4];


  // Was axios.get(BASE_URL + '/super_admin_settings/') fired on mount; now
  // backed by useSuperAdminSettings. Kept as an effect (not derived) since
  // userComment stays plain editable state that checkResponder below (and
  // the textarea onChange) also write to, same as before.
  const { data: superAdminSettings } = useSuperAdminSettings();
  useEffect(() => {
    if (!superAdminSettings) return;
    const fullPrompt = `${superAdminSettings?.data?.default_prompt?.default_p1} ${superAdminSettings?.data?.default_prompt?.default_p2} ${superAdminSettings?.data?.default_prompt?.default_p3}`
    setPreFixPrompt(superAdminSettings?.data?.default_prompt?.default_p1);
    setPostFixPrompt(superAdminSettings?.data?.default_prompt?.default_p3);
    setUserComment(fullPrompt);
  }, [superAdminSettings]);

  // Was two separate axios.post(BASE_URL + '/accounts/checkcrmagent...')
  // calls hitting the same route (this one read apiKey, fetchCRMAgentStatus
  // further down read status) — one shared useCheckCrmAgent query now backs
  // both, deduped to a single request.
  const { data: crmAgentCheck, refetch: refetchCrmAgentCheck } = useCheckCrmAgent(activeLocation?.id);
  useEffect(() => {
    if (crmAgentCheck) setApiKey(crmAgentCheck?.data?.apiKey);
  }, [crmAgentCheck]);

  useEffect(() => {
    checkSlackconnection()
  }, []);

  // Was a raw axios.get(`${BASE_URL}/assistant/fetchbyuser...`) fired once on
  // mount via useEffect(..., []); now backed by the shared useAgentsList query
  // (also used by usersContext.js, ApiAccess/index.js, addwebsites/index.js
  // and uploadFiles/index.js) so a write on the Agents page invalidates this
  // dropdown too. selectionData is purely derived, matching the three
  // original states: [] while loading, [initalAssistant] on error, else the
  // full status-filtered list.
  const { data: agentsFetchData, isError: agentsFetchError } = useAgentsList(userInfo._id, userActiveLocation?.id);

  const selectionData = useMemo(() => {
    const initalAssistant = {
      assistant_name: "Brand AI",
      modal_name: "openai/gpt-4o",
      assistant_id: userActiveLocation?.assistant_id,
      status: true
    };
    if (agentsFetchError) return [initalAssistant].filter(item => item.status);
    if (!agentsFetchData) return [];
    return [initalAssistant, ...(agentsFetchData?.data || [])].filter(item => item.status);
  }, [agentsFetchData, agentsFetchError, userActiveLocation?.assistant_id]);

  const checkResponder = async () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {}
    };
    await axios.request(config)
      .then((response) => {
        const exists = response.data.find(item => item.profile_id === activeLocation?.id);
        if (exists) {
          setIsToggled(exists?.status)
          setMyResponder(exists);
          setUserComment(exists?.prompt)
        } else {
          setMyResponder();
          setIsToggled(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const extractMiddleContent = (fullContent) => {
    if (fullContent?.startsWith(preFixPrompt) || fullContent?.endsWith(postFixPrompt)) {
      return fullContent?.slice(preFixPrompt.length, fullContent?.length - postFixPrompt.length).trim();
    } else {
      console.error('Prefix or postfix does not match the full content!');
      return '';
    }
  }
  useEffect(() => {
    setTimeout(() => {
      checkResponder();
    }, 2000);
  }, [])

  const handleConnectWithFacebook = (e) => {
    e.preventDefault();
    let redirectType = 'stand_alone';
    if (checkIfGhlUser) {
      redirectType = 'GHL'
    }
    window.location.href = `https://connect.maybetech.com/?profile_id=${activeLocation?.id}&email=${user?.email}&username=${user?.first_name}&type=${redirectType}`;
  };


  const saveAccountTokenMutation = useSaveAccountToken();
  const handleConnect = async (e) => {
    setProcessing(true)
    const payload = {
      account_id: activeLocation?.id,
      agency_id: activeLocation?.agency_id,
    }
    let response;
    try {
      response = await saveAccountTokenMutation.mutateAsync(payload);
    } catch (error) {
      setProcessing(false)
      return;
    }
    if (response) {
      setProcessing(false)
      saveActiveLocation(response?.data)
    }
    // const { response } = await AppService.accounts.save_account_token({
    //   payload,
    // });
    // try {
    //   const sessionKey = await localforage.getItem("sessionKey") || GHLSessionKey;
    //   setisModalOpen(true);
    //   // if (!sessionKey) {
    //   //   setModalcontent("no_session")
    //   // } else {
    //   const market_url = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.ACCOUNT}&client_id=${env.GHL.ACCOUNT_CLIENT_ID}&scope=${env.GHL.ACCOUNT_SCOPE}&state=${activeLocation?.id}`
    //   setModalcontent(market_url)
    //   // }
    // } catch (error) {
    //   console.error('Error fetching sessionKey from localforage:', error);
    //   alert("Something went wrong");
    // }
  };
  const handleConnectWithSlack = (e) => {
    e.preventDefault();
    // let redirectType = 'stand_alone';
    // if (checkIfGhlUser) {
    //   redirectType = 'GHL'
    // }
    window.open(
      `https://europe-west2-slack-app-public-oauth.cloudfunctions.net/slack-app-public-oauth-prod/slack/auth?profile_id=${activeLocation?.id}`,
      '_blank'
    );
  };
  const createApiKeyMutation = useCreateApiKey();
  const handleCreateApiKey = async (e) => {
    const payload = {
      profileid: activeLocation?.id,
    };

    let response;
    try {
      response = await createApiKeyMutation.mutateAsync(payload);
    } catch (error) {
      return;
    }
    if (response) {
      UpdateUser(response.data);
      refetchCrmAgentCheck();
    }
  }

  const connectWithNango = async () => {
    setNangoLogin(true);
  }

  const handleToggleVisibility = () => {
    setShowApiKey(!showApiKey);
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      alert("API key copied to clipboard");
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };
  const [confrirmModel, SetconfrirmModel] = useState(false);
  const handleToggle = (checked) => {

    if (!checked) {
      SetconfrirmModel(true)
    } else {
      setIsToggled(checked);
    }
  };
  const TurnOff = () => {
    updateRespondr(false)
    setIsToggled(false);
    SetconfrirmModel(false)
  }
  const saveResponder = async () => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = JSON.stringify({
      "profile_id": activeLocation?.id,
      "status": isToggled,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "assistant_id": selectedOption?.value
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://metaconnect.maybetech.com/api/responders',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };
    try {
      let res = await axios.request(config)
        .then((response) => {
          setUserComment(response?.data?.prompt)
          setMyResponder(response?.data);
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }

  const updateRespondr = async (status = true) => {
    setProcessing(true);
    let promptToSave = userComment;
    if (updatedByUser) {
      promptToSave = `${preFixPrompt} ${userComment} ${postFixPrompt}`
    }
    let data = {
      "profile_id": activeLocation?.id,
      "status": status,
      "prompt": promptToSave,
      "prompt_custom": userComment,
      "prompt_prefix": preFixPrompt,
      "id": myResponder?.id,
      "assistant_id": selectedOption?.value
    };
    setUserComment(userComment)
    setMyResponder(data);
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `https://metaconnect.maybetech.com/api/responders/${myResponder?.id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data)
    };
    try {
      await axios.request(config)
        .then((response) => {
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("Error")
    }

  }
  // Was its own axios.post(BASE_URL + '/accounts/checkcrmagent', ...) fired
  // on mount into local state; now just derived off the shared
  // useCheckCrmAgent query above (same route as the apiKey read).
  const isConnectedCRM = !!crmAgentCheck?.status;

  const createCrmAgentMutation = useCreateCrmAgent();
  const handleConnectWithCRMAgent = (value) => {
    setisCRMLoaderModal(true)

    const payload = {
      agency_id: agencyData._id,
      api_type: "team",
      instructions: "CRM AGENT",
      model: "openai/gpt-4o",
      name: "CRM AGENT",
      profile_id: activeLocation?.id,
      readonly: true,
      status: false,
      temperature: 0.5,
      templatename: "CRM AGENT",
      top_p: 0.8,
      type: "agency",
      locationid: agencyData?.ghl?.location_id,
      handler: value
    }

    createCrmAgentMutation.mutate(payload, {
      onSuccess: () => {
        refetchCrmAgentCheck();
        setisCRMLoaderModal(false);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }
  const saveThirdPartyFiles = async (assistant) => {
    var response = await contextuploadFilefrominput(thirdPartFiles, userActiveLocation?.id, user?.userName, assistant);
    if (response === "uploaded") {
      setModelContent("file Submitted ..!")
      setOpenAssistantModal(false);
      setSuccessModel(true)
      // refreshchat();
    }
  }



  const handleAssistantSelect = (selected) => {
    setSelectedOption(selected)
  }

  // const handlesave = (e) => {
  //     e.preventDefault();
  //     if (selectedOption.length > 0) {
  //         setLoader(true);
  //         saveThirdPartyFiles(selectedOption)
  //         localStorage.removeItem('uploadedFiles');
  //         setAssistantError(false)
  //     } else {
  //         setAssistantError(true)
  //     }
  // }
  useEffect(() => {
    // Try to find the assistant_id match from myResponder
    const matchedAssistant = selectionData?.find(item => item?.assistant_id === myResponder?.assistant_id);

    if (matchedAssistant) {
      // If found, set the matched assistant as selected
      setSelectedOption({
        label: matchedAssistant.assistant_name,
        value: matchedAssistant.assistant_id
      });
    } else {
      // If no match, find the "Brand AI" option
      const defaultAssistant = selectionData?.find(item => item?.assistant_name === "Brand AI");
      if (defaultAssistant) {
        // If "Brand AI" is found, set it as default
        setSelectedOption({
          label: defaultAssistant.assistant_name,
          value: defaultAssistant.assistant_id
        });
      }
    }
  }, [myResponder?.assistant_id, selectionData]);
  const [isConnectedtoslack, setIsConnectedtoslack] = useState(false);
  const [assistants, setassistants] = useState([]);
  const [streamingApi, setStreamingApi] = useState(userActiveLocation?.is_streaming_Api || false);
  const [selectedAssistant, setselectedAssistant] = useState({});
  const [teamId, setTeamId] = useState('')

  const updateStreamingApiMutation = useUpdateStreamingApi();
  const handleStreamApi = async () => {
    const updatedStream = !streamingApi;
    setStreamingApi(updatedStream);
    try {
      const result = await updateStreamingApiMutation.mutateAsync({
        id: userActiveLocation.id,
        streamingApi: updatedStream,
      });

      if (result?.success) {
        saveActiveLocation(result?.data)
      } else {
        console.error('Failed to update account');
      }
    } catch (error) {
      console.error('Error updating account:', error);
    }

  }



  const checkSlackConnectionMutation = useCheckSlackConnection();
  const fetchSlackConnectionMutation = useFetchSlackConnection();
  const updateSlackConnectionMutation = useUpdateSlackConnection();
  const checkSlackconnection = async () => {
    let response;
    try {
      response = await checkSlackConnectionMutation.mutateAsync(activeLocation?.id);
    } catch (error) {
      return;
    }
    if (response?.data.connected == true) {
      setIsConnectedtoslack(true);
      fetchSlackconnection(response.data?.teams[0]?.teamId)
    }
  }
  const fetchSlackconnection = async (team_id) => {
    let response;
    try {
      response = await fetchSlackConnectionMutation.mutateAsync({ profileId: activeLocation?.id, teamId: team_id });
    } catch (error) {
      return;
    }
    if (response.success) {
      if (response.data.assistants)
        setassistants(response.data.assistants);
      const matchedRecord = response.data.assistants.find(
        (item) => item.assistant_id === response.data.selectedAssistantId
      );
      setTeamId(response.data.teamId)
      setselectedAssistant(matchedRecord);
    }
  }

  const handleDropdownAction = async (item) => {
    const payload = { profile_id: activeLocation.id, teamId: teamId, assistant_id: item.assistant_id };
    let response;
    try {
      response = await updateSlackConnectionMutation.mutateAsync(payload);
    } catch (error) {
      return;
    }
    if (response.success) {
      fetchSlackconnection(teamId)
    }
  };
  //agent listed in the dropdown
  // Same /assistant/fetchbyuser data as selectionData above (reuses the
  // already-fetched agentsFetchData/agentsFetchError instead of firing a
  // second axios.get), just rearranged/matched against the user's default
  // assistant. assistantData/asistantSelected are purely derived now: both
  // collapse to [initalAssistant]/initalAssistant while loading OR on error,
  // matching the original useState initializers + catch branch exactly.
  const initalAssistant = useMemo(() => ({
    assistant_name: "Brand AI",
    modal_name: "openai/gpt-4o",
    assistant_id: user?.assistant_id,
    status: true
  }), [user?.assistant_id]);

  const { assistantData, asistantSelected } = useMemo(() => {
    const rawList = agentsFetchData?.data;
    if (agentsFetchError || !rawList) {
      return { assistantData: [initalAssistant].filter(item => item.status), asistantSelected: initalAssistant };
    }
    let filteredResponse = rawList.filter(item => item.status && item.ui_enable);
    const match = filteredResponse.find(item => item.assistant_id === user.default_assistant);
    let rearrangedResponse = [];
    if (match) {
      rearrangedResponse = [
        { ...match, selected: true },
        initalAssistant,
        ...filteredResponse
          .filter(item => item.assistant_id !== user.default_assistant)
          .map(item => ({ ...item, selected: false })),
      ];
    } else {
      rearrangedResponse = [
        initalAssistant,
        ...filteredResponse.map(item => ({ ...item, selected: false })),
      ];
    }

    let selected = initalAssistant;
    if (agentsFetchData?.crm_agent) {
      rearrangedResponse.push({
        assistant_name: "CRM Agent",
        modal_name: "openai/gpt-4o",
        assistant_id: agentsFetchData?.crm_agent,
        status: true
      })
    } else {
      selected = rearrangedResponse[0];
    }
    return { assistantData: rearrangedResponse, asistantSelected: selected };
  }, [agentsFetchData, agentsFetchError, initalAssistant, user?.default_assistant]);
  return (
    <div className="">
      {/* 
      <div className="form-border p-5 mb-6">
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
          <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Enable Streaming Api</h2>
          <div style={{ padding: "10px 0" }}>
            <div
              onClick={handleStreamApi}
              className={`w-14 h-8 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer transition-colors duration-300 ${streamingApi ? 'bg-blue-500' : 'bg-gray-300'
                }`}
            >
              <div
                className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${streamingApi ? 'translate-x-6' : ''
                  }`}
              ></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="form-border p-5 mb-6">
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
          <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Connect to Slack</h2>
          <div style={{ padding: "10px 0" }}>
            {isConnectedtoslack ? (
              <div style={{ width: "100%", maxWidth: "300px" }}>
                <select
                  value={selectedAssistant?.assistant_id || ""}
                  onChange={(e) =>
                    handleDropdownAction(
                      assistantData.find((item) => item.assistant_id === e.target.value)
                    )
                  }
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    padding: "10px 20px",
                    border: "1px solid gray",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    width: "100%", // Full width for responsiveness
                    maxWidth: "300px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <option value="" disabled>
                    Select Assistant
                  </option>
                  {assistantData?.map((item) => (
                    <option key={item.assistant_id} value={item.assistant_id}>
                      {item.assistant_name}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <button
                onClick={(e) => handleConnectWithSlack(e)}
                className="px-10 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold"
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  padding: "10px 20px",
                  textAlign: "center",
                }}
              >
                Connect
              </button>
            )}
          </div>
        </div>
      </div> */}
      {/* <div className="form-border p-5 mb-6">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>CRM Agent</h2>
          </div>
          <div className="flex justify-end" style={{ textAlign: 'right' }}>
            {isConnectedCRM ? <>
              <button className="px-10 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={() => handleConnectWithCRMAgent("disconnect")}>
                Update Agent
              </button>

            </> :
              <button className="px-10 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={() => handleConnectWithCRMAgent("connect")}>
                Create Agent
              </button>
            }
          </div>
        </div>
      </div> */}
      {/* <div className="mb-6 form-border" style={{ marginTop: "20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
          <h2 className="py-2" style={{ fontSize: "20px", fontWeight: "bold" }}>Auto-reply to Facebook and Instagram comments</h2>
          <div style={{ padding: "10px 0" }}>
            <Switch
              onChange={handleToggle}
              checked={isToggled}
              offColor="#888"
              onColor="#0b0"
              offHandleColor="#fff"
              onHandleColor="#fff"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              height={24}
              width={48}
            />
          </div>
        </div>
        {isToggled ? <div className="positionrelative">
          <textarea rows={10} style={{ width: "100%", border: "1px solid gray", padding: '6px' }} onChange={(e) => { setUserComment(e.target.value); setUpdatedByUser(true) }}>{myResponder ? myResponder?.prompt_custom : extractMiddleContent(userComment)}</textarea>

          <div className="pen_icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_16_185)">
                <path d="M1.5 10.35L0 15L4.65 13.5L1.5 10.35Z" fill="#757575" />
                <path d="M9.87189 1.95383L2.55347 9.27225L5.7354 12.4542L13.0538 5.13576L9.87189 1.95383Z" fill="#757575" />
                <path d="M14.775 2.325L12.675 0.225C12.375 -0.075 11.925 -0.075 11.625 0.225L10.95 0.9L14.1 4.05L14.775 3.375C15.075 3.075 15.075 2.625 14.775 2.325Z" fill="#757575" />
              </g>
              <defs>
                <clipPath id="clip0_16_185">
                  <rect width="15" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <SelectAssistant saveThirdPartyFiles={saveThirdPartyFiles} selectionData={selectionData} onClose={() => setOpenAssistantModal(false)} hidebtn={true} />


          <div>
            <div style={{ marginBottom: "10px" }}>
                <b>Select Assistant</b>
            </div>

            <div>
              {assistantError ? <span style={{ color: "red" }}>Please select an assistant *</span> : ""}
              <Select closeMenuOnSelect={true}
                options={selectionData?.filter(item => !item.readonly)?.map((item) => ({
                  label: item.assistant_name,
                  value: item.assistant_id
                }))}
                onChange={handleAssistantSelect}
                value={selectedOption}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "hsl(var(--border))",  // Custom border color
                    marginTop: '6px',  // Add margin of 20px
                    marginBottom: '20px'  // Add margin of 20px
                  })
                }}  // Custom border color
              />
            </div>
            

        </div>



          <div style={{ textAlign: "right" }}>
            <button className="savebtnonproptpage" onClick={myResponder !== undefined ? () => updateRespondr() : saveResponder}>
              {processing && <SvgIcon id={'spinner'} color={'#fff'} />}
              {myResponder !== undefined ? 'Update' : 'Save'}
            </button>
          </div>
        </div> : ''}
      </div> */}

      <NangoIntegration locationId={userActiveLocation?.id} userInfo={user} />
      {/* <div className="form-border p-5 mb-6">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h2 className="py-0" style={{ fontSize: "20px", fontWeight: "bold" }}>Create API key</h2>
            <a href="https://apidocs.maybetech.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "underline", fontWeight: 400, fontSize: '16px' }}>
              View docs
            </a>
          </div>
          <div className="flex justify-end" style={{ alignItems: 'right' }}>
            {apiKey ? (
              <>
                <div style={{ marginRight: '20px', fontWeight: 'bold' }}>
                  {showApiKey ? apiKey : '************************'}
                </div>
                <button className="px-2 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={handleCopy}>
                  Copy
                </button>
                <button className="px-2 ms-2 py-2 text-xs bg-blue-800 text-white rounded-md uppercase font-bold" onClick={handleToggleVisibility}>
                  {showApiKey ? 'Hide' : 'Show'}
                </button>
              </>
            ) : (
              <button className="px-10 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={handleCreateApiKey}>
                Generate Api Key
              </button>
            )}
          </div>
        </div>
      </div> */}
      {/* {checkIfGhlUser &&
        <div className="form-border p-5">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={agencyData?.Customization?.ghl_connect_logo ? agencyData?.Customization?.ghl_connect_logo : 'https://www.gstatic.com/webp/gallery3/1.sm.png'} style={{ height: '50px', marginRight: '10px' }} alt="" />
              <div>
                <h2 style={{ fontSize: "20px", fontWeight: "bold" }}>{agencyData?.Customization?.ghl_connect_heading ? agencyData?.Customization?.ghl_connect_heading : 'Connect With GHL'}</h2>
                <strong style={{ color: '#918c8c' }}>{agencyData?.Customization?.ghl_connect_sub_heading ? agencyData?.Customization?.ghl_connect_sub_heading : 'Connect your account with GHL'}</strong>
              </div>
            </div>

            <div className="flex justify-end">
              <button className="px-10 py-2 text-xs bg-green-800 text-white rounded-md uppercase font-bold" onClick={handleConnect}>
                {processing && (<SvgIcon id={'spinner'} color="#fff" />)}
                {activeLocation?.ghl ? ' Connnected' : ' Connect'}
              </button >
            </div >
          </div >
        </div >} */}
      {

        isCRMLoaderModal &&
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
          onClick={() => setisCRMLoaderModal(false)}
        >
          <div
            className="bg-card rounded-lg shadow-lg p-6 relative w-96"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              className="absolute top-3 right-3 text-muted-foreground cursor-pointer hover:text-foreground"
              onClick={() => setisCRMLoaderModal(false)}
            >
              X
            </p>
            <div className="text-center">
              <p className="text-lg font-medium mb-4">It Will Take Some Time</p>
              <div className="flex items-center justify-center space-x-2 mt-4">
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse"></span>
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse delay-300"></span>
                <span className="w-3 h-3 bg-foreground rounded-full animate-pulse delay-600"></span>
              </div>
            </div>
          </div>
        </div>

      }

      {
        isModalOpen && (
          <div className="modal-zz" onClick={() => setisModalOpen(false)}>
            <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
              <p
                style={{
                  position: "absolute",
                  right: 0,
                  width: "12px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setisModalOpen(false)}
              >
                X
              </p>
              {Modalcontent == "no_session" ?
                <b>Something went wrong please refresh the page</b>
                :
                <iframe style={{ height: "80vh", width: "100%", overflow: 'scroll' }} src={Modalcontent}></iframe>
              }
            </div>
          </div>

        )
      }
      {
        confrirmModel &&
        <div className="modal-zz-confirm" onClick={() => SetconfrirmModel(false)}>

          <div className="scrollable-modal-content bg-card  rounded" style={{ border: "1px solid hsl(var(--border)) " }}>
            <p className="modalText">
              Are you sure you want to turn off Auto-reply to Facebook and Instagram comments?
            </p>
            <div className="modalBtnGroup">
              <button className="agreeBtn" onClick={TurnOff}>
                Turn off
              </button>
              <p className="disagreeBtn" onClick={() => SetconfrirmModel(false)}>
                Cancel
              </p>
            </div>
          </div>
        </div>


      }

    </div >
  );
}
export default IntegrationsContent;



